"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesUtils = exports.SimpleFuturesOrderSubject = void 0;
const rxjs_1 = require("rxjs");
const Trade_1 = require("../../../component/Trade");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const TradeValidate_1 = require("../../Trade/FutureTrade/TradeValidate");
/** 简易合约 - 下单推送数据流 */
exports.SimpleFuturesOrderSubject = new rxjs_1.Subject();
var SimpleFuturesUtils;
(function (SimpleFuturesUtils) {
    /**
     * 是否是可用的 wss 推送的值
     * @returns boolean
     */
    const isValidWSSValue = (value) => {
        return value !== null && value !== undefined;
    };
    /**
     * 仓位是否处于结算中
     * @param order
     */
    function isSettleOrder(order) {
        return [interface_1.OrderInnerStatus.ClosePosition, interface_1.OrderInnerStatus.ClearStrategy].includes(order.inner_status);
    }
    SimpleFuturesUtils.isSettleOrder = isSettleOrder;
    /**
     * 是否是未触发的条件单
     * @param order
     */
    function isWaitingTriggerOrder(order) {
        if (order.mode !== interface_1.SimpleFutures.OrderMode.Trigger) {
            return false;
        }
        // 初始状态main_loop_status为空，当做未触发
        if (!order.main_loop_status) {
            return true;
        }
        return order.main_loop_status === "waiting_trigger";
    }
    SimpleFuturesUtils.isWaitingTriggerOrder = isWaitingTriggerOrder;
    /**
     * 是否待成交的限价单
     * @param order
     */
    function isWaitingLimitOrder(order) {
        if (order.mode !== interface_1.SimpleFutures.OrderMode.Limit) {
            return false;
        }
        if (!order.limit_order_status) {
            // 初始状态limit_order_status为空，当做待成交
            return true;
        }
        return order.limit_order_status === "WaitingFill";
    }
    SimpleFuturesUtils.isWaitingLimitOrder = isWaitingLimitOrder;
    /**
     * 是否等待开仓的订单(条件单、限价单)
     */
    function isWaitingOpenOrder(order) {
        return isWaitingTriggerOrder(order) || isWaitingLimitOrder(order);
    }
    SimpleFuturesUtils.isWaitingOpenOrder = isWaitingOpenOrder;
    /**
     * 未完全成交的仓位,对应订单过滤的waiting_trigger条件，待开仓仓位
     * @param order
     */
    function isNotFullFilledOrder(order) {
        if (order.limit_order_status === "PartialFilled") {
            // 部分成交在过滤订单列表时算作待开仓仓位
            return true;
        }
        return isWaitingOpenOrder(order);
    }
    SimpleFuturesUtils.isNotFullFilledOrder = isNotFullFilledOrder;
    /**
     * 计算数据，添加一些后端没有返回，但是可以直接计算得到的值
     * @param data SimpleFutures.SimpleFuturesOrder
     * @returns SimpleFutures.SimpleFuturesOrder
     */
    const addCalcData = (data) => {
        let tp_sl_params;
        try {
            tp_sl_params = (() => {
                if (data.tp_sl_v2) {
                    return JSON.parse(data.tp_sl_v2);
                }
                if (data.tp_sl) {
                    const old = JSON.parse(data.tp_sl);
                    return {
                        profit: { mode: old.mode, details: [{ value: old.data.profit_rate }] },
                        loss: { mode: old.mode, details: [{ value: old.data.loss_rate }] },
                    };
                }
                return undefined;
            })();
        }
        catch (_a) { }
        return Object.assign(Object.assign({}, data), { history_position_avg_price: SimpleFuturesUtils.getHistoryPositionAVGPrice(data), close_position_avg_price: SimpleFuturesUtils.getClosePositionAVGPrice(data), 
            // 待开仓订单使用触发价计算
            active_position_avg_price: isWaitingOpenOrder(data) ? data.price : SimpleFuturesUtils.getActivePositionAVGPrice(data), takeover_mark_price: SimpleFuturesUtils.getTakeoverMarkPrice(data), forced_liquidation_fee: SimpleFuturesUtils.getTakeoverFee(data), tp_sl_params: tp_sl_params, is_settling: isSettleOrder(data), is_waiting_trigger: isWaitingTriggerOrder(data), is_waiting_limit: isWaitingLimitOrder(data), is_triggered_trailing: !new trade_utils_lib_1.SafeDecimal(data.hl_reach_price).eq(0), is_bonus: Boolean(data.investment_from === interface_1.SimpleFutures.InvestmentFrom.FUTURES_LITE_BONUS && data.bonus_id) });
    };
    /**
     * 历史仓位的开仓均价：isLong ? avgLong : avgShort
     * avgLong = -amountLong / qtyLong
     * avgShort = -amountShort / qtyShort
     */
    SimpleFuturesUtils.getHistoryPositionAVGPrice = (position) => {
        if (position.side === interface_1.CustomOrderSide.BUY) {
            return new trade_utils_lib_1.SafeDecimal(position.qty_long).eq(0)
                ? undefined
                : new trade_utils_lib_1.SafeDecimal(-1).times(new trade_utils_lib_1.SafeDecimal(position.amount_long)).div(new trade_utils_lib_1.SafeDecimal(position.qty_long)).toString();
        }
        return new trade_utils_lib_1.SafeDecimal(position.qty_short).eq(0)
            ? undefined
            : new trade_utils_lib_1.SafeDecimal(-1).times(new trade_utils_lib_1.SafeDecimal(position.amount_short)).div(new trade_utils_lib_1.SafeDecimal(position.qty_short)).toString();
    };
    /**
     * 平仓均价： isLong ? avgShort : avgLong
     * avgLong = -amountLong / qtyLong
     * avgShort = -amountShort / qtyShort
     */
    SimpleFuturesUtils.getClosePositionAVGPrice = (position) => {
        if (position.side === interface_1.CustomOrderSide.BUY) {
            return new trade_utils_lib_1.SafeDecimal(position.qty_short).eq(0)
                ? undefined
                : new trade_utils_lib_1.SafeDecimal(-1).times(new trade_utils_lib_1.SafeDecimal(position.amount_short)).div(new trade_utils_lib_1.SafeDecimal(position.qty_short)).toString();
        }
        return new trade_utils_lib_1.SafeDecimal(position.qty_long).eq(0)
            ? undefined
            : new trade_utils_lib_1.SafeDecimal(-1).times(new trade_utils_lib_1.SafeDecimal(position.amount_long)).div(new trade_utils_lib_1.SafeDecimal(position.qty_long)).toString();
    };
    /**
     * 活跃仓位持仓均价（完全成交后的实际成交均价）：
     * -1*(amountLong+amountShort+amountSettle)/(qtyLong+qtyShort)
     */
    SimpleFuturesUtils.getActivePositionAVGPrice = (position) => {
        const amount = new trade_utils_lib_1.SafeDecimal(position.amount_long)
            .add(new trade_utils_lib_1.SafeDecimal(position.amount_short))
            .add(new trade_utils_lib_1.SafeDecimal(position.amount_settle));
        const qty = new trade_utils_lib_1.SafeDecimal(position.qty_long).add(new trade_utils_lib_1.SafeDecimal(position.qty_short));
        if (qty.eq(0)) {
            return undefined;
        }
        else {
            return amount.div(qty).times(-1).toString();
        }
    };
    /**
     * 强平标记价格: takeover_amount / takeover_qty
     * @param position: SimpleFutures.SimpleFuturesOrder
     * @returns string | undefined
     */
    SimpleFuturesUtils.getTakeoverMarkPrice = (position) => {
        const qty = new trade_utils_lib_1.SafeDecimal(position.takeover_qty);
        if (qty.eq(0)) {
            return undefined;
        }
        return new trade_utils_lib_1.SafeDecimal(position.takeover_amount).div(qty).toString();
    };
    /**
     * 强平手续费:
     * @param position: SimpleFutures.SimpleFuturesOrder
     * @returns string | undefined
     */
    SimpleFuturesUtils.getTakeoverFee = (position) => {
        const liqFeeRate = Trade_1.CalculateUtils.getSymbolLiqFeeRate(`${position.base}/${position.quote}`);
        return new trade_utils_lib_1.SafeDecimal(position.takeover_amount).times(new trade_utils_lib_1.SafeDecimal(liqFeeRate)).toString();
    };
    /**
     * 转换 restFull api 数据为 SimpleFutures.SimpleFuturesOrder
     * @returns SimpleFutures.SimpleFuturesOrder
     */
    SimpleFuturesUtils.transferOrderAPIToUI = (data) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        const portfolio = (_a = data === null || data === void 0 ? void 0 : data.bu_order_data) === null || _a === void 0 ? void 0 : _a.portfolio[0];
        return addCalcData({
            bu_order_id: data.bu_order_id,
            bu_order_type: data.bu_order_type,
            quote: data.quote,
            create_time: data.create_time,
            close_time: data.close_time,
            status: data.status,
            inner_status: (_b = data.bu_order_data) === null || _b === void 0 ? void 0 : _b.status,
            funding_fee: ((_c = data.bu_order_data) === null || _c === void 0 ? void 0 : _c.funding_fee) || "0",
            fee: ((_d = data.bu_order_data) === null || _d === void 0 ? void 0 : _d.fee) || "0",
            quote_amount: ((_e = data.bu_order_data) === null || _e === void 0 ? void 0 : _e.quote_amount) || "0",
            quote_invest: ((_f = data.bu_order_data) === null || _f === void 0 ? void 0 : _f.quote_invest) || "0",
            transfer_in: ((_g = data.bu_order_data) === null || _g === void 0 ? void 0 : _g.transfer_in) || "0",
            transfer_out: ((_h = data.bu_order_data) === null || _h === void 0 ? void 0 : _h.transfer_out) || "0",
            profit: ((_j = data.bu_order_data) === null || _j === void 0 ? void 0 : _j.profit) || "0",
            reason_by: (_k = data.bu_order_data) === null || _k === void 0 ? void 0 : _k.reason_by,
            lack_of_margin: (_m = (_l = data.bu_order_data) === null || _l === void 0 ? void 0 : _l.lack_of_margin) !== null && _m !== void 0 ? _m : false,
            main_loop_status: (_o = data.bu_order_data) === null || _o === void 0 ? void 0 : _o.main_loop_status,
            limit_order_status: (_p = data.bu_order_data) === null || _p === void 0 ? void 0 : _p.limit_order_status,
            investment_from: (_q = data.bu_order_data) === null || _q === void 0 ? void 0 : _q.investment_from,
            bonus_id: (_r = data.bu_order_data) === null || _r === void 0 ? void 0 : _r.bonus_id,
            bonus_fee: (_s = data.bu_order_data) === null || _s === void 0 ? void 0 : _s.bonus_fee,
            bonus_recovered_principal: (_t = data.bu_order_data) === null || _t === void 0 ? void 0 : _t.bonus_recovered_principal,
            bonus_fee_ratio: (_u = data.bu_order_data) === null || _u === void 0 ? void 0 : _u.bonus_fee_ratio,
            cost: (_v = data.bu_order_data) === null || _v === void 0 ? void 0 : _v.cost,
            base: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.base) || "",
            leverage: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.leverage) || 0,
            side: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.side) || "buy",
            mode: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.mode) || interface_1.SimpleFutures.OrderMode.Market,
            price: portfolio === null || portfolio === void 0 ? void 0 : portfolio.price,
            qty_long: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.qty_long) || "0",
            qty_short: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.qty_short) || "0",
            amount_long: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.amount_long) || "0",
            amount_short: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.amount_short) || "0",
            amount_settle: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.amount_settle) || "0",
            maint_price: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.maint_price) || "0",
            takeover_amount: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.takeover_amount) || "0",
            takeover_qty: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.takeover_qty) || "0",
            tp_sl: portfolio === null || portfolio === void 0 ? void 0 : portfolio.tp_sl,
            tp_sl_v2: portfolio.tp_sl_v2,
            hl_reach_price: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.hl_reach_price) || "0",
            hl_reach_ratio: portfolio.hl_reach_ratio || "0",
        });
    };
    /**
     * 转换 web socket 数据为 SimpleFutures.SimpleFuturesOrder
     * @returns SimpleFutures.SimpleFuturesOrder
     */
    SimpleFuturesUtils.transferWSSOrderAPIToUI = (wssData = {}) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const buOrderData = (wssData === null || wssData === void 0 ? void 0 : wssData.bu_order_data) || {};
        const portfolio = buOrderData.portfolio[0] || {};
        const parseOrder = {
            bu_order_id: wssData.bu_order_id,
            bu_order_type: wssData.bu_order_type,
            quote: wssData.quote,
            status: wssData.status,
            create_time: buOrderData.open_time,
            close_time: buOrderData.close_time,
            inner_status: buOrderData.status,
            funding_fee: (_a = buOrderData.funding_fee) === null || _a === void 0 ? void 0 : _a.toString(),
            fee: (_b = buOrderData.fee) === null || _b === void 0 ? void 0 : _b.toString(),
            quote_amount: (_c = buOrderData.quote_amount) === null || _c === void 0 ? void 0 : _c.toString(),
            quote_invest: (_d = buOrderData.quote_invest) === null || _d === void 0 ? void 0 : _d.toString(),
            transfer_in: (_e = buOrderData.transfer_in) === null || _e === void 0 ? void 0 : _e.toString(),
            transfer_out: (_f = buOrderData.transfer_out) === null || _f === void 0 ? void 0 : _f.toString(),
            profit: (_g = buOrderData.profit) === null || _g === void 0 ? void 0 : _g.toString(),
            reason_by: buOrderData.reason_by,
            lack_of_margin: buOrderData.lack_of_margin,
            main_loop_status: buOrderData.main_loop_status,
            limit_order_status: buOrderData.limit_order_status,
            investment_from: buOrderData.investment_from,
            bonus_id: buOrderData.bonus_id,
            bonus_fee: buOrderData.bonus_fee,
            bonus_recovered_principal: buOrderData.bonus_recovered_principal,
            bonus_fee_ratio: buOrderData.bonus_fee_ratio,
            cost: buOrderData.cost,
            base: portfolio.base,
            side: portfolio.side,
            mode: portfolio.mode,
            price: portfolio.price,
            leverage: portfolio.leverage,
            qty_long: (_h = portfolio.qty_long) === null || _h === void 0 ? void 0 : _h.toString(),
            qty_short: (_j = portfolio.qty_short) === null || _j === void 0 ? void 0 : _j.toString(),
            amount_long: (_k = portfolio.amount_long) === null || _k === void 0 ? void 0 : _k.toString(),
            amount_short: (_l = portfolio.amount_short) === null || _l === void 0 ? void 0 : _l.toString(),
            amount_settle: (_m = portfolio.amount_settle) === null || _m === void 0 ? void 0 : _m.toString(),
            maint_price: (_o = portfolio.maint_price) === null || _o === void 0 ? void 0 : _o.toString(),
            takeover_amount: (_p = portfolio.takeover_amount) === null || _p === void 0 ? void 0 : _p.toString(),
            takeover_qty: (_q = portfolio.takeover_qty) === null || _q === void 0 ? void 0 : _q.toString(),
            tp_sl: portfolio.tp_sl,
            tp_sl_v2: portfolio.tp_sl_v2,
            hl_reach_price: (_r = portfolio.hl_reach_price) === null || _r === void 0 ? void 0 : _r.toString(),
            hl_reach_ratio: (_s = portfolio.hl_reach_ratio) === null || _s === void 0 ? void 0 : _s.toString(),
            position_id: portfolio.position_id,
        };
        // 过滤掉 value 不满足 isValidWSSValue 的键值对，返回空字符串
        const order = Object.entries(parseOrder).reduce((result, [key, value]) => {
            if (isValidWSSValue(value)) {
                result[key] = value;
            }
            return result;
        }, {});
        return addCalcData(order);
    };
    /**
     * 获取仓位总利润，支持活跃仓位、历史仓位
     */
    SimpleFuturesUtils.getTotalProfit = (position, latest) => {
        if (!position) {
            return new trade_utils_lib_1.SafeDecimal(0);
        }
        const isHistoryPosition = position.status !== "open";
        if (isHistoryPosition) {
            /** 订单总成本：quote_invest + (transfer_in - transfer_out) */
            const totalOrderCost = new trade_utils_lib_1.SafeDecimal(position.quote_invest)
                .add(new trade_utils_lib_1.SafeDecimal(position.transfer_in || 0))
                .sub(new trade_utils_lib_1.SafeDecimal(position.transfer_out || 0));
            /** 总利润：max(-订单总成本，quote_amount - 订单总成本） */
            return trade_utils_lib_1.SafeDecimal.max(totalOrderCost.times(-1), new trade_utils_lib_1.SafeDecimal(position.quote_amount).sub(totalOrderCost));
        }
        if (new trade_utils_lib_1.SafeDecimal(position.qty_long).eq(0) && new trade_utils_lib_1.SafeDecimal(position.qty_short).eq(0)) {
            return new trade_utils_lib_1.SafeDecimal(0);
        }
        return new trade_utils_lib_1.SafeDecimal(position.quote_amount)
            .add(new trade_utils_lib_1.SafeDecimal(latest || 0)
            .sub(position.active_position_avg_price || 0)
            .times(new trade_utils_lib_1.SafeDecimal(position.qty_long).add(new trade_utils_lib_1.SafeDecimal(position.qty_short))))
            .sub(position.quote_invest)
            .sub(new trade_utils_lib_1.SafeDecimal(position.transfer_in || 0).sub(new trade_utils_lib_1.SafeDecimal(position.transfer_out || 0)));
    };
    /**
     * 根据冲击限制，判断限价单挂单价格合法
     */
    function checkLimitPriceImpact({ triggerPrice, indexPrice, symbol, side, }) {
        var _a;
        if ((_a = symbol.originData) === null || _a === void 0 ? void 0 : _a.max_impact_limit) {
            const checkPriceD = new trade_utils_lib_1.SafeDecimal(indexPrice);
            if (checkPriceD.greaterThan(0)) {
                // 限价单最大冲击价格比率
                const maxImpactLimit = symbol.originData.max_impact_limit;
                const triggerPriceD = new trade_utils_lib_1.SafeDecimal(triggerPrice);
                if (side === interface_1.CustomOrderSide.BUY) {
                    // 禁止过高买入
                    const maxPrice = checkPriceD.div(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(maxImpactLimit)));
                    if (triggerPriceD.greaterThan(maxPrice)) {
                        throw (0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(errors_1.TRADE_LIMIT_PRICE_HIGH).message;
                    }
                }
                else {
                    // 禁止过低卖出
                    const minPrice = checkPriceD.mul(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(maxImpactLimit)));
                    if (triggerPriceD.lessThan(minPrice)) {
                        throw (0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(errors_1.TRADE_LIMIT_PRICE_LOW).message;
                    }
                }
            }
        }
    }
    SimpleFuturesUtils.checkLimitPriceImpact = checkLimitPriceImpact;
    /**
     * 通过市价防冲击比例计算市价防冲击价格
     * @param symbolInfo
     * @param orderSide
     * @param markPrice
     */
    function calcMaxImpactMarketPrice({ symbolInfo, orderSide, markPrice, }) {
        var _a;
        const maxImpactMarket = TradeValidate_1.TradeValidator.getMaxImpactMarket(symbolInfo);
        const markPriceD = new trade_utils_lib_1.SafeDecimal(markPrice);
        const priceD = (() => {
            if (orderSide === interface_1.CustomOrderSide.BUY) {
                // 放大价格
                return markPriceD.div(new trade_utils_lib_1.SafeDecimal(1).sub(maxImpactMarket));
            }
            // 减小价格
            return markPriceD.mul(new trade_utils_lib_1.SafeDecimal(1).sub(maxImpactMarket));
        })();
        return priceD.toDP((_a = symbolInfo.precision) !== null && _a !== void 0 ? _a : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    }
    SimpleFuturesUtils.calcMaxImpactMarketPrice = calcMaxImpactMarketPrice;
})(SimpleFuturesUtils = exports.SimpleFuturesUtils || (exports.SimpleFuturesUtils = {}));
